import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { InternalAdminFeatureComponent } from './internal-admin-feature/internal-admin-feature.component';

const log = new LoggingService();

export const InternalAdminRoute: Ng2StateDeclaration = {
    name: 'admin',
    url: '/admin',
    data: { requiresAuth: true },

    component: InternalAdminFeatureComponent
};
